"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findCheapestCombination = void 0;
const findLowestScoringCombinationIndex_1 = require("./findLowestScoringCombinationIndex");
const generateCombinations_1 = require("./generateCombinations");
const findCheapestCombination = (ideal_order, coursesIds, pricingDays) => {
    const validDays = pricingDays.filter((day) => day?.courses?.some((course) => course.rate > 0));
    const courseInstances = coursesIds.reduce((acc, id) => ({
        ...acc,
        [id]: (acc[id] || 0) + 1,
    }), {});
    const allCombinations = (0, generateCombinations_1.generateCombinations)(validDays, courseInstances);
    // what is the lowest cost possible across all combinations by summing the rates
    const lowest_possible_cost = allCombinations.reduce((acc, combination) => {
        const total_cost = combination.reduce((total, { rate }) => total + rate, 0);
        return total_cost < acc ? total_cost : acc;
    }, Infinity);
    // filter the combinations to only ones that match the lowest possible cost
    const allCombinationsWithLowestCost = allCombinations.filter((combination) => {
        const total_cost = combination.reduce((total, { rate }) => total + rate, 0);
        return total_cost === lowest_possible_cost;
    });
    const allCombinationsIds = allCombinationsWithLowestCost.map((combination) => combination.map((c, idx) => {
        return {
            id: `${c.course_id}`,
            score: idx + 1,
        };
    }));
    const order_ranking = ideal_order.map((id, idx) => {
        return {
            id: `${id}`,
            score: (ideal_order.length - idx) / 10,
        };
    });
    const lowestIndex = (0, findLowestScoringCombinationIndex_1.findLowestScoringCombinationIndex)(order_ranking, allCombinationsIds);
    if (lowestIndex === -1) {
        return [];
    }
    return allCombinationsWithLowestCost[lowestIndex];
};
exports.findCheapestCombination = findCheapestCombination;
